import { FormControl } from "@angular/forms";

export function cepValidator(control: FormControl) {
    const valor = control?.value ? control?.value.replace(/[^0-9]/g, '') : control?.value;
    const cepRegex = /^[0-9]{5}-?[0-9]{3}$/;
    if (valor && !cepRegex.test(valor)) {
        return { cep: true };
    }
    return null;
}

